function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.338 42.484s6.265-10.49-5.012-13.987c-4.26-1.321-12.53-2.332-20.049-4.663C10.438 23.264 1 26.648 1 25c0-3.497 5.012-4.662 5.012-4.662s-3.235-8.485 3.76-12.822c3.758-2.331 8.846-2.48 16.915 1.166 11.904 5.828 27.36 20.747 10.651 33.802z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 20.5a.5.5 0 11-1 0 .5.5 0 111 0z",
  transform: "matrix(1.25304 0 0 1.16558 -1.506 -8.22)",
  strokeWidth: 0.827,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.76 25c5.011-1.166 7.517-4.662 7.517-4.662",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.053 7.516c-.812-2.646 15.03-6.08 12.53-3.496-4.51 4.662-5.011 6.993-5.011 6.993"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.049 16.84s5.069 9.22 6.265 6.994c1.253-2.33 1.253-6.993 1.253-6.993",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.338 42.484s-7.518-2.331-10.024-4.663c-2.307-2.145 0 6.994 6.265 6.994-1.253 6.993 6.265 10.49 5.012 8.159-2.241-4.17-1.253-10.49-1.253-10.49"
}));

var SvgDolphin = function SvgDolphin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDolphin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Dolphin.f692a67d.svg";
export { ForwardRef as ReactComponent };